// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_50-6";
export var headerCell = "_50-2";
export var loadingStateContent = "_50-8";
export var rowWrapper = "_50-4";
export var stickyAggregationCell = "_50-b";
export var stickyAggregationRow = "_50-7";
export var stickyColumnCell = "_50-a";
export var stickyColumnHeaderCell = "_50-9";
export var table = "_50-1";
export var virtualRowWrapper = "_50-5";
export var virtualTableContainer = "_50-0";
export var white = "_50-3";